import { Component, OnInit, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { ToggleService } from '../../shared/toggle-service/toggle.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
import * as build from '../../../../build-version.json';

@Component({
  standalone: false,
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit {
  server_environment: string;
  server_version: string;
  isAdmin: boolean;
  currentYear: number;

  constructor(
    readonly toggleService: ToggleService,
    readonly location: Location,
    readonly userService: UserService,
  ) {
    this.server_environment = window.location.host.split(/[.]/)[0].split(/[-]/)[0].split(':')[0];
    this.server_version = `Termhub version: ${environment.version}
Build version: `;

    try {
      this.server_version += build?.buildVersion;
    } catch (e) {
      console.warn(e);
    }
    //**keep this console.log in the source code to display the build version in the browser console
    console.log(this.server_version);
    this.checkScreenSize();
  }

  ngOnInit(): void {
    const userData = JSON.parse(localStorage.getItem('user_data'));
    this.isAdmin = userData?.role === 'ADMIN';
    this.currentYear = new Date().getFullYear();
  }

  navigateToTH() {
    window.location.href = 'https://www.terminologyhub.com';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (window.innerWidth <= 768) {
      this.toggleService.toggleSidebarFixed();
      this.removeClassToBodyForResponsiveMenu();
    } else {
      this.toggleService.toggleSidebarFlex();
      this.removeClassToBodyForResponsiveMenu();
    }
  }

  removeClassToBodyForResponsiveMenu(): any {
    const body = document.querySelector('body');
    if (body.classList.contains('menu-toggle')) {
      body.classList.remove('menu-toggle');
    }
  }
}
